import React from 'react';
import NumberedSections from '../../components/NumberedSections';
import { getSlaSections } from './utils';

/**
 * The SLA Requirements tab of a shipper's profile: the shipper's requirements for each delivery
 * type, one dotted line per requirement. Read only; the text is the shipper's
 * `clients.special_instructions_settings`, which the carrier's account query already loads.
 * @param {{ partnership: Object }} props
 */
const SlaRequirementsPage = ({ partnership }) => (
    <NumberedSections
        marker="dot"
        sections={getSlaSections(partnership.shipper?.special_instructions_settings)}
        getItemKey={(line, index) => `${index}-${line}`}
        renderItem={(line) => <span className="text-sm text-foreground/80">{line}</span>}
    />
);

export default SlaRequirementsPage;
